import React, { useState, useEffect } from 'react';
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import Typography from '@mui/joy/Typography';
import Sheet from '@mui/joy/Sheet';

import { toast } from "react-hot-toast";

import API_BASE_URL from '../../../../config/config.js';
import axios from 'axios';

const ModalFormUpdate = ({ open, setOpen, rowData, fetchSkeletonMatches }) => {
    // Estado para manejar los valores de los inputs, con valores iniciales desde rowData
    const [formData, setFormData] = useState({
        idskeletonmatch: "",
        idtypephase: "",
        nro_fecha: "",
        idgrupo1: "",
        idgrupo2: "",
        nro_grupo1: "",
        nro_grupo2: "",
        date_match: "",
        time_match: "",
        idsede: "",
        tag_final: "",
        nro_match: ""
    });

    useEffect(() => {
        // Cargar los valores de rowData al abrir el modal
        console.log("info id", rowData.idskeletonmatch)
        console.log("info rowData", rowData)
        if (rowData) {
            setFormData({
                idskeletonmatch: rowData.idskeletonmatch,
                idtypephase: rowData.idtypephase || "",
                nro_fecha: rowData.nro_fecha || "",
                idgrupo1: rowData.idgrupo1 || "",
                idgrupo2: rowData.idgrupo2 || "",
                nro_grupo1: rowData.nro_grupo1 || "",
                nro_grupo2: rowData.nro_grupo2 || "",
                date_match: rowData.date_match || "",
                time_match: rowData.time_match || "",
                idsede: rowData.idsede || "",
                tag_final: rowData.tag_final || "",
                nro_match: rowData.nro_match || ""
            });
        }
    }, [rowData]);

    // Manejar cambios en los inputs
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    // Manejar el envío del formulario
    const handleSubmit = async (e) => {
        e.preventDefault();
        // Aquí agregar la lógica para actualizar la data
        console.log("Actualizando datos con:", formData);
        try {
            const response = await axios.patch(`${API_BASE_URL}/updateskeletonmatch`, formData)
            toast.success("Skeleton Actualizado con Éxito")
            setOpen(false)
            fetchSkeletonMatches()
        } catch (error) {
            toast.error("Error al actualizar el skeleton")
            console.error("Error al actualizar skeleton match")
        }
    };

    return (
        <Modal
            aria-labelledby="modal-title"
            aria-describedby="modal-desc"
            open={open}
            onClose={() => setOpen(false)}
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
            <Sheet
                variant="outlined"
                sx={{ maxWidth: 600, borderRadius: 'md', p: 4, boxShadow: 'lg' }}
            >
                <ModalClose variant="plain" sx={{ m: 1 }} />
                <Typography
                    component="h2"
                    id="modal-title"
                    level="h4"
                    textColor="inherit"
                    sx={{ fontWeight: 'lg', mb: 3 }}
                >
                    Actualizar Registro
                </Typography>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {[
                            { label: "ID Type Phase", name: "idtypephase" },
                            { label: "Nro Fecha", name: "nro_fecha" },
                            { label: "ID Grupo 1", name: "idgrupo1" },
                            { label: "ID Grupo 2", name: "idgrupo2" },
                            { label: "Nro Grupo 1", name: "nro_grupo1" },
                            { label: "Nro Grupo 2", name: "nro_grupo2" },
                            { label: "Date Match", name: "date_match", type: "date" },
                            { label: "Time Match", name: "time_match", type: "time" },
                            { label: "ID Sede", name: "idsede" },
                            { label: "Tag Final", name: "tag_final" },
                            { label: "Nro Match", name: "nro_match" },
                        ].map((field) => (
                            <div key={field.name} className="space-y-1">
                                <label className="text-sm font-medium text-gray-700">
                                    {field.label}
                                </label>
                                <input
                                    type={field.type || "text"}
                                    name={field.name}
                                    value={formData[field.name]}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                />
                            </div>
                        ))}
                    </div>
                    <div className="flex justify-end mt-4">
                        <button
                            type="submit"
                            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition duration-200"
                        >
                            Actualizar Data
                        </button>
                    </div>
                </form>
            </Sheet>
        </Modal>
    );
}

export default ModalFormUpdate;
